export const accept = '.xlsx,.xls,image/*,.doc,.docx,.htm,.html,.pdf';

export function isValidFile(fileExtension: string): boolean {
  const FileTypes = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'html',
    'htm',
    'jpeg',
    'jpg',
    'png',
    'bmp',
    'tiff',
    'gif',
  ];
  return FileTypes.indexOf(fileExtension.toLowerCase()) > -1;
}

export function getEncodedFilePath(fileUri: string): string {
  let filePath = 'root';
  const pathModules = fileUri.split('/');
  for (let i = 4; i < pathModules.length; i++) {
    filePath = filePath + '/' + pathModules[i];
  }

  //replace the fileURI as encodedURI. Special characters are not allowed inside <a href> tag
  filePath = filePath.replace(/%20/g, ' ');
  const encodedFilePath = encodeURIComponent(filePath);

  return encodedFilePath
    .replace("'", '%27')
    .replace('!', '%21')
    .replace('~', '%7E')
    .replace('(', '%28')
    .replace(')', '%29')
    .replace('.', '%2E');
}

export function checkAzureFileNameValidation(fileName: string): string {
  const illegalChars = /[\\\/:;*?"`'<>|^@%!(){}\[\]&+=#~$\x00-\x1F]/;
  const endsWithPeriod = /\.$/;
  const trimmedFileName = fileName.trim();
  if (!trimmedFileName) {
    return 'Title should not be empty.';
  }
  if (illegalChars.test(trimmedFileName)) {
    return 'Title should not contain invalid characters:  / : ; * ? " < > | ^ @ % ( ) { } [ ] & + = # ~ $ ! `\'';
  } else if (endsWithPeriod.test(trimmedFileName)) {
    return 'Title cannot end with a period (.)';
  } else if (trimmedFileName.length > 255) {
    return 'Title cannot be longer than 255 characters';
  } else {
    return 'Valid';
  }
}
